import React from "react";
import {Language} from "../../functions/CommonFunctions";
import Image from "next/image";
import Link from "next/link";
import { NavigationURLs } from "../../functions/NavigationFunctions";
import { ContactContentWrapper } from "./ContactContentStyled";
import GeneralBreadcrumb from "../breadcrumb/GeneralBreadcrumbComp";

const SupportData = [
    {
        'icon': '/next/assets/images/email-icon.svg',
        'title': 'E-posta:',
        'detail': `${Language('email')}`,
        'icon_width': 90,
        'icon_height': 86,
        // 'ilgili_kisi': 'kvk@pembepanjur.com',
    },
    {
        'icon': '/next/assets/images/support-phone-icon.svg',
        'title': 'Destek Hattı Telefon:',
        'detail': `${Language('destek_hatti_phone')}`,
        'icon_width': 70,
        'icon_height': 58,
        'work_time': `${Language('working_hours')}`
    },
    {
        'icon': '/next/assets/images/support-wp-icon.svg',
        'title': 'WhatsApp Destek Hattı:',
        'detail': `${Language('whatsapp_destek_phone')}`,
        'icon_width': 84,
        'icon_height': 83,
        'work_time': `${Language('working_hours')}`
    },
    {
        'icon': '/next/assets/images/support-fax-icon.svg',
        'title': 'Destek Hattı Faks:',
        'detail': `${Language('destek_hatti_fax')}`,
        'icon_width': 81,
        'icon_height': 90
    }
]

const ContactContent = () => {
    const breadcrumbItems = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Müşteri Hizmetleri'}
    ];

    return (
        <React.Fragment>
            <ContactContentWrapper>
                <GeneralBreadcrumb items={breadcrumbItems} colorProps={false} margin={false}/>
                <div className="contact-content-row">
                    <h2>
                        Pembe Panjur Müşteri Hizmetleri:
                    </h2>

                    <div className="container">
                        <div className="wrapper">
                            <div className="pp-contact-info">
                                {SupportData.map((data) =>
                                    <React.Fragment key={Math.random()}>
                                        <div className="info-wrapper">
                                            <div className="icon">
                                                <Image src={`${data.icon}`} alt={'Pembe Panjur'} width={data.icon_width}
                                                       height={data.icon_height}/>
                                            </div>
                                            <div className="contact-content">
                                                <div className="title">
                                                    {data.title}
                                                </div>
                                                <div className="detail">
                                                    <Link
                                                        href={data.detail === `${Language('email')}` ? `mailto:${data.detail}` : `tel:${data.detail}`}>
                                                        {data.detail}
                                                    </Link>
                                                    {/*{data.ilgili_kisi === undefined ? null : <Link href={`mailto:${data.ilgili_kisi}`}>{data.ilgili_kisi}</Link>}*/}
                                                </div>
                                                {data.work_time === '' ? null : <div className="detail">
                                                    {data.work_time}
                                                </div>}
                                            </div>
                                        </div>

                                    </React.Fragment>)}
                            </div>
                        </div>
                        <div className="wrapper">
                            <div className="pp-contact-company-detail">
                                <div className="pp-contact-address">
                                    <div className="company-info">
                                        <div className="company-text">
                                            Firma: &nbsp;
                                            <span>{Language('company_name')}</span>
                                        </div>
                                        <div className="company-text">
                                            Adres: &nbsp;
                                            <span>{Language('address')}</span>
                                        </div>
                                        <div className="company-text">
                                            Mersis No: &nbsp;
                                            <span>{Language('mersis_no')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="pp-contact-faq">
                                    <div className="faq-icon">
                                        <Image src={'/next/assets/images/sss-icon.png'} alt={'Pembe Panjur Sıkça Sorulan Sorular'} width={97} height={125}/>
                                    </div>
                                    <div className="faq-text">
                                        <p>
                                            Sıkça Sorulan Sorular
                                        </p>
                                        SSS için
                                        buraya <Link href={NavigationURLs.support}>
                                        tıklayın.
                                    </Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </ContactContentWrapper>

        </React.Fragment>
    )
}

export default ContactContent;
